import { jsx as _jsx } from "react/jsx-runtime";
import CalculateIcon from '@mui/icons-material/Calculate';
import CampaignIcon from '@mui/icons-material/Campaign';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import CloudIcon from '@mui/icons-material/Cloud';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import ExploreIcon from '@mui/icons-material/Explore';
import ExtensionIcon from '@mui/icons-material/Extension';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import RuleIcon from '@mui/icons-material/GavelOutlined';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import GroupRemoveIcon from '@mui/icons-material/GroupRemove';
import HistoryIcon from '@mui/icons-material/History';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import MapIcon from '@mui/icons-material/Map';
import NetworkCheckIcon from '@mui/icons-material/NetworkCheck';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import PersonIcon from '@mui/icons-material/Person';
import HandshakeIcon from '@mui/icons-material/Handshake';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import SettingsIcon from '@mui/icons-material/Settings';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import SmsIcon from '@mui/icons-material/Sms';
import StackedLineChartIcon from '@mui/icons-material/StackedLineChart';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import WarningIcon from '@mui/icons-material/Warning';
import { ActionIcons, DomainIcons, getIconForType, TypeIcons } from '../../../Iconography';
import { CategoryToTreeLeaf } from '../navDefinitionToTree';
import { NavSections } from '../NavSections';
export const containerLinks = {
    Alerts: { id: 'Alerts', name: 'Alerts', type: 'link', icon: NotificationsActiveIcon, link: `${NavSections.ALERT_MANAGEMENT}` },
    AreaManagement: { id: 'AreaManagement', name: 'AreaManagement', type: 'link', icon: ExploreIcon, link: NavSections.HOME },
    AwsMetrics: { id: 'AwsMetrics', name: 'Metrics', type: 'link', icon: StackedLineChartIcon, link: NavSections.AWSMETRICS },
    AwsGateways: { id: 'AwsGateways', name: 'AWS', type: 'link', icon: DomainIcons.Cloud, link: NavSections.AWSGATEWAYS },
    Broadcast: { id: 'Broadcast', name: 'Broadcast', type: 'link', icon: CampaignIcon, link: NavSections.BROADCAST },
    CalculatedStates: { id: 'CalculatedStates', name: 'Calculated States', type: 'link', icon: CalculateIcon, link: NavSections.CALCULATED_STATES },
    Comparison: { id: 'Comparison', name: 'Comparison', type: 'link', icon: CompareArrowsIcon, link: NavSections.COMPARISONVIEW },
    ComparisonView: { id: 'ComparisonView', name: 'Comparison', type: 'link', icon: CompareArrowsIcon, link: NavSections.COMPARISONVIEW },
    Datatable: { id: 'Datatable', name: 'By Type', type: 'link', icon: SettingsIcon, link: NavSections.DATATABLEVIEW },
    DeviceAcceptance: { id: 'DeviceAcceptance', name: 'Acceptance', type: 'link', icon: PlaylistAddCheckIcon, link: NavSections.DEVICE_ACCEPTANCE },
    DeviceAssignment: { id: 'DeviceAssignment', name: 'Assignment', type: 'link', icon: GroupAddIcon, link: NavSections.DEVICE_ASSIGNMENT },
    DeviceInvestigation: { id: 'DeviceInvestigation', name: 'Investigation', type: 'link', icon: TroubleshootIcon, link: NavSections.DEVICE_INVESTIGATION },
    DeviceSummary: { id: 'DeviceSummary', name: 'Summary', type: 'link', icon: ManageSearchIcon, link: NavSections.DEVICE_SUMMARY },
    Diagnostic: { id: 'Diagnostic', name: 'Diagnostic', type: 'link', icon: MapIcon, link: NavSections.DIAGNOSTIC },
    GatewayAssignment: { id: 'GatewayAssignment', name: 'Assignment', type: 'link', icon: GroupAddIcon, link: NavSections.GATEWAY_ASSIGNMENT },
    GatewayList: { id: 'GatewayList', name: 'Gateways', type: 'link', icon: getIconForType('Gateway'), link: NavSections.GATEWAY_LIST },
    GatewayUnassignment: { id: 'GatewayUnassignment', name: 'Unassignment', type: 'link', icon: GroupRemoveIcon, link: NavSections.GATEWAY_UNASSIGNMENT },
    Groups: { id: 'Groups', type: 'link', name: 'Smart Groups', icon: PersonIcon, link: NavSections.THINGSVIEW + '/AggregationGroup' },
    Partners: { id: 'Partners', type: 'link', name: 'Partners', icon: HandshakeIcon, link: NavSections.THINGSVIEW + '/Partner' },
    ImportExport: { id: 'ImportExport', type: 'link', name: 'Import / Export', icon: ActionIcons.ImportExport, link: NavSections.IMPORT_EXPORT },
    Incidents: { id: 'Incidents', name: 'Incidents', type: 'link', icon: WarningIcon, link: `${NavSections.NOTIFICATIONS}?tabName=Incidents` },
    LNSIntegrations: { id: 'LNSIntegrations', name: 'Integrations', type: 'link', icon: DomainIcons.Cloud, link: `${NavSections.Integrations}` },
    LNSList: {
        id: 'LNSList',
        name: 'LNS',
        type: 'link',
        icon: TypeIcons.LoRaWANApplicationServer,
        link: `${NavSections.THINGVIEW}/LoRaWANApplicationServer/?adjacencyType=SUBJECT&currentContextSearchMode=NO_CONTEXT`,
    },
    MapView: { id: 'MapView', name: 'Map View', type: 'link', icon: MapIcon, link: NavSections.MAPVIEW },
    MobileDevices: {
        id: 'MobileDevices',
        name: 'Mobile devices',
        type: 'link',
        icon: SmartphoneIcon,
        link: `${NavSections.NOTIFICATIONS}?tabName=Mobile%20devices`,
    },
    NetworkCoverage: { id: 'NetworkCoverage', name: 'Coverage', type: 'link', icon: NetworkCheckIcon, link: NavSections.NETWORKCOVERAGE },
    NetworkList: { id: 'NetworkList', name: 'Networks', type: 'link', icon: CloudIcon, link: NavSections.NETWORK_LIST },
    NetworkMonitoring: { id: 'NetworkMonitoring', name: 'Messages', type: 'link', icon: NetworkCheckIcon, link: NavSections.NETWORKTABLEVIEW },
    Notifications: { id: 'Notifications', name: 'Notifications', type: 'link', icon: SmsIcon, link: `${NavSections.NOTIFICATIONS}?tabName=Notifications` },
    PayloadDefinitions: { id: 'PayloadDefinitions', name: 'Payload Definitions', icon: CloudDoneIcon, link: NavSections.PAYLOAD_DEFINITIONS },
    PayloadParser: { id: 'PayloadParser', name: 'Payload Parser', type: 'link', icon: ManageSearchIcon, link: NavSections.PAYLOAD_PARSER },
    ProjectConfig: { id: 'ProjectConfig', name: 'Project Config', icon: ToggleOnIcon, link: NavSections.PROJECT_CONFIG },
    PrivacyPolicy: { id: 'PrivacyPolicy', name: 'Privacy Policy', type: 'link', icon: PrivacyTipIcon, link: NavSections.PRIVACY_POLICY },
    Rules: { id: 'Rules', name: 'Rules', type: 'link', icon: RuleIcon, link: NavSections.RULE_MANAGEMENT },
    Rulesets: { id: 'Rulesets', name: 'Rule Sets', type: 'link', icon: SettingsIcon, link: `${NavSections.NOTIFICATIONS}?tabName=Rulesets` },
    Subscriptions: {
        id: 'Subscriptions',
        name: 'Subscriptions',
        type: 'link',
        icon: FormatListBulletedIcon,
        link: `${NavSections.NOTIFICATIONS}?tabName=Subscriptions`,
    },
    SystemLogs: { id: 'SystemLogs', name: 'Logs', type: 'link', icon: HistoryIcon, link: NavSections.SYSTEM_LOGS },
    SystemStatus: { id: 'SystemStatus', name: 'Status', type: 'link', icon: DomainIcons.Cloud, link: NavSections.SYSTEM_SELF_CHECK },
    Userview: { id: 'Userview', name: 'Userview', type: 'link', icon: PersonIcon, link: NavSections.USERVIEW },
    Wideawake: { id: 'Wideawake', name: 'Wideawake', type: 'link', icon: CrisisAlertIcon, link: NavSections.WIDEAWAKE },
    WidgetPlayground: { id: 'WidgetPlayground', name: 'Widget Playground', type: 'link', icon: ExtensionIcon, link: NavSections.WIDGET_PLAYGROUND },
};
const getContainerLinkTreeItemFns = () => {
    const fns = Object.fromEntries(Object.entries(containerLinks).map(([key, def]) => {
        return [key, ({ contextCustomer }) => _jsx(CategoryToTreeLeaf, { keyIn: key, navDefinition: def, contextObject: contextCustomer }, key)];
    }));
    return fns;
};
const ContainerLinkTreeItemFns = getContainerLinkTreeItemFns();
export { ContainerLinkTreeItemFns };
